import styled from 'styled-components';

import { humanizeStyleLabel } from '../../utils/documentStyleGroups';
import type { DocumentStyleInput } from './GlobalProperties.types';

interface Props {
	input: DocumentStyleInput;
	onChange: (value: string) => void;
}

const NumberField = styled.span`
	display: inline-flex;
`;

export const DocumentStyleField = ({ input, onChange }: Props) => {
	const label = humanizeStyleLabel(input.label);

	if (input.type === 'select' && input.options) {
		return (
			<div data-re-inspector-prop-row="">
				<label data-re-inspector-label="">{label}</label>
				<select
					data-re-inspector-select=""
					aria-label={label}
					value={String(input.value ?? '')}
					onChange={(event) => onChange(event.currentTarget.value)}
				>
					{Object.entries(input.options).map(([value, optionLabel]) => (
						<option key={value} value={value}>
							{optionLabel}
						</option>
					))}
				</select>
			</div>
		);
	}

	return (
		<div data-re-inspector-prop-row="">
			<label data-re-inspector-label="">{label}</label>
			<NumberField data-re-inspector-number="">
				<input
					data-re-inspector-input=""
					type="text"
					inputMode="numeric"
					aria-label={label}
					value={String(input.value ?? '')}
					onChange={(event) => onChange(event.currentTarget.value)}
				/>
				{input.unit && <span data-re-inspector-unit="">{input.unit}</span>}
			</NumberField>
		</div>
	);
};
